import React, {useCallback, useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import ChampionFilter from "../../../Champions/ChampionsContent/ChampionFilter";
import ChampionsHeader from "../../../Champions/ChampionsContent/ChampionsHeader";
import ChampionsWhiteWrapper from "../../../Champions/ChampionsContent/ChampionsWhiteWrapper";
import useQueryVersion from "../../../../common/hooks/useQueryVersion";
import useQueryTier from "../../../../common/hooks/useQueryTier";
import AramRankTable from "./AramRankTable";
import useScrollPagination from "../../../../common/hooks/useScrollPagination";
import useTitleAndDescription from "../../../../common/hooks/useTitleAndDescription";


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 590px;
  margin-left: 10px;
`;



const AramRank = () => {
    const {t} = useTranslation();
    const championRanks = useSelector((state) => state?.champions?.ranks);
    const history = useHistory();
    const [currentVersion, onChangeCurrentVersion] = useQueryVersion();
    const [currentTier, onChangeCurrentTier] = useQueryTier();
    const [pageValue] = useScrollPagination();
    const theme = useTheme();

    const getSelectedRank = useMemo(() => {
        try {
            return championRanks.all;
        } catch (e) {
            return [];
        }
    }, [championRanks])


    const onSelectVersion = useCallback((version) => {
        history.replace(`/aram?version=${version}&tier=${currentTier}`);
        onChangeCurrentVersion(version);
    }, [currentTier]);

    const onSelectTier = useCallback((tier) => {
        history.replace(`/aram?version=${currentVersion}&tier=${tier}`);
        onChangeCurrentTier(tier)
    }, [currentVersion]);

    useTitleAndDescription({
        title: t('header.titleAram'),
        description: t('header.titleAramDescription',{
            version: currentVersion,
        })
    })


    return (
        <Wrapper>
            <ChampionsHeader
                title={t('championAnalyze.championRanking')}
            >
                <ChampionFilter
                    disableTier={true}
                    borderColor={theme.color.default_border_color}
                    currentVersion={currentVersion}
                    selectVersion={onSelectVersion}
                    currentTier={currentTier}
                    selectTier={onSelectTier}
                />
            </ChampionsHeader>
            <ChampionsWhiteWrapper>
                <AramRankTable
                    pageValue={pageValue}
                    ranks={getSelectedRank}
                />
            </ChampionsWhiteWrapper>
        </Wrapper>
    );
};

export default AramRank;
